import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS_MAP_URL } from '../config/businessInfo';
import './PolicyPages.css';

const WarrantyPage = () => {
    return (
        <div className='policy-page'>
            <div className='policy-hero'>
                <div className='container'>
                    <h1>Warranty Policy (Rahber Corporation, Since 1980)</h1>
                    <p>
                        High-quality home appliances and reliable after-sales
                        support.
                    </p>
                </div>
            </div>

            <div className='container policy-body'>
                <article className='policy-prose'>
                    <p className='lead'>
                        At Rahber Corporation, we are committed to providing
                        high-quality home appliances and reliable after-sales
                        support.
                    </p>

                    <h2>1. Warranty coverage</h2>
                    <ul>
                        <li>
                            Warranty is provided on eligible products purchased
                            from Rahber Corporation.
                        </li>
                        <li>
                            It covers manufacturing defects and functional
                            issues under normal use.
                        </li>
                        <li>
                            Warranty coverage may vary depending on the product
                            and manufacturer.
                        </li>
                    </ul>

                    <h2>2. Warranty period</h2>
                    <ul>
                        <li>The warranty duration is defined by the manufacturer.</li>
                        <li>The warranty period starts from the date of purchase.</li>
                        <li>
                            Customers must keep the original purchase receipt as
                            proof.
                        </li>
                    </ul>

                    <h2>3. Warranty claim process</h2>
                    <p>To claim warranty:</p>
                    <ul>
                        <li>Provide the original purchase receipt or invoice.</li>
                        <li>
                            Contact our customer support or{' '}
                            <a
                                href={BUSINESS_MAP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                visit our Lahore showroom (Google Maps)
                            </a>
                            .
                        </li>
                        <li>
                            Our team will guide you through the verification
                            process.
                        </li>
                    </ul>

                    <h2>4. Warranty exclusions</h2>
                    <p>Warranty will <strong>not</strong> cover:</p>
                    <ul>
                        <li>
                            Damage due to misuse, mishandling, or negligence.
                        </li>
                        <li>Improper installation or incorrect usage.</li>
                        <li>Accidental damage.</li>
                        <li>Unauthorized repairs or modifications.</li>
                        <li>Use of incompatible accessories.</li>
                        <li>
                            Damage due to incorrect voltage or power issues.
                        </li>
                        <li>Missing or altered serial number.</li>
                        <li>
                            Consumable items (for example filters, bulbs, and
                            similar items).
                        </li>
                    </ul>

                    <h2>5. Repair, replacement, or refund</h2>
                    <p>If a warranty claim is approved:</p>
                    <ul>
                        <li>The product may be repaired, replaced, or refunded.</li>
                        <li>
                            The decision depends on the nature of the defect and
                            the availability of parts or replacement.
                        </li>
                    </ul>

                    <h2>6. Transportation and risk</h2>
                    <ul>
                        <li>
                            Customers are responsible for safe packaging of the
                            product.
                        </li>
                        <li>
                            Transportation costs (to and from the service
                            location) may be borne by the customer.
                        </li>
                        <li>
                            Rahber Corporation is not responsible for damage
                            during transit.
                        </li>
                    </ul>

                    <h2>7. Warranty limitations</h2>
                    <ul>
                        <li>Warranty is valid only for the original purchaser.</li>
                        <li>Warranty is non-transferable.</li>
                        <li>
                            Applicable only within the operating region of our
                            business.
                        </li>
                    </ul>

                    <h2>8. Customer responsibilities</h2>
                    <p>Customers must:</p>
                    <ul>
                        <li>
                            Follow proper installation and usage instructions.
                        </li>
                        <li>Provide accurate details during a claim.</li>
                        <li>
                            Include, where possible: the product with original
                            packaging, accessories, a fault description, and a
                            copy of the invoice.
                        </li>
                    </ul>

                    <h2>9. Manufacturer warranty</h2>
                    <p>
                        Some products may include an additional manufacturer
                        warranty.
                    </p>
                    <ul>
                        <li>
                            Customers should refer to the manufacturer&apos;s
                            warranty card or documentation.
                        </li>
                        <li>Manufacturer terms may apply separately.</li>
                    </ul>

                    <h2>10. Customer support</h2>
                    <p>
                        At Rahber Corporation, we aim to assist all our customers
                        as quickly as possible.
                    </p>
                    <ul>
                        <li>
                            <strong>Support hours:</strong> Monday to Saturday,
                            11:00 AM to 8:00 PM (closed Sundays and public
                            holidays).
                        </li>
                        <li>
                            <strong>Mobile:</strong>{' '}
                            <a href='tel:+923131451223'>0313-1451223</a>,{' '}
                            <a href='tel:+923218878772'>0321-8878772</a>
                        </li>
                        <li>
                            <strong>PTCL:</strong>{' '}
                            <a href='tel:+924237145264'>042-37145264</a>
                        </li>
                        <li>
                            <strong>Complaints (Rizwan):</strong>{' '}
                            <a href='tel:+923074470641'>0307-4470641</a>
                        </li>
                        <li>
                            <strong>Email:</strong>{' '}
                            <a href='mailto:Rahbercorporation1@gmail.com'>
                                Rahbercorporation1@gmail.com
                            </a>
                        </li>
                    </ul>
                    <div className='policy-note'>
                        <strong>Please note:</strong> During peak hours or busy
                        periods, our customer support team may take a little
                        longer to respond. We appreciate your patience and assure
                        you that every query will be handled as soon as possible.
                        For faster assistance, we recommend contacting us during
                        non-peak hours.
                    </div>

                    <p>
                        Questions? See <Link to='/faq'>FAQ</Link> or{' '}
                        <Link to='/contact'>Contact</Link> us.
                    </p>

                    <p className='policy-meta'>Last updated: April 2026</p>
                </article>
            </div>
        </div>
    );
};

export default WarrantyPage;
